import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ExpandableContent } from "../../../components/CustomControls/ExpandableContent";
import { PersonalHistory } from "../../../components/MedicalRecords/PersonalHistory";
import { usePersonalHistories } from "../Hooks/usePersonalHistory";
import { useAdverseEventHistoryByConcept } from "../Hooks/useAdverseEvents";
import { AuditModal } from "../../../components/AuditTrail/AuditModal";
import { AuditTrail } from "../../Admin/AuditTrail";
import { ModalConceptHistory } from "../Modals/ModalConceptHistory";

export const PersonalHistoryListContainer = ({ entryId, mrn, medicalRecordNumber, expandedAll }) => {
    const { t } = useTranslation();
    const [personalHistory, query, totalSize, isLoading, handleTableChange, , setSearchTerm] = usePersonalHistories(medicalRecordNumber, entryId);

    const [modal, setModal] = useState(null);
    const handleAuditTrail = (entityId) => {
        setModal(
            <AuditModal
                onClose={() => { setModal(null); }}
                title={t("auditTrail.audit")}
            >
                <AuditTrail entity="PersonalHistory" entityId={entityId} medicalRecordNumber={medicalRecordNumber} />
            </AuditModal>
        )
    }
    const handleHistoryByConcept = (conceptId, _mrn) => {
        setModal(<ModalConceptHistory
            onClose={() => { setModal(null); }}
            title={t("medicalRecords.history.byConcept")}
            medicalRecordNumber={medicalRecordNumber || mrn}
            conceptId={conceptId}
            useHistoryHook={useAdverseEventHistoryByConcept}
            getConceptName={(row) => row.adverseEffect}
            getCycleSubtitle={(row) => row.intensity || ''}
        />)
    }

    if (entryId && totalSize === 0)
        return null;
        
    return (
        <ExpandableContent title={t("medicalRecords.personalHistory.title")} content="personalHistory" expandedAll={expandedAll}>
            {modal}
            <PersonalHistory
                withCard={false}
                data={personalHistory}
                query={query}
                entryId={entryId}
                totalSize={totalSize}
                isLoading={isLoading}
                onTableChange={handleTableChange}
                onAuditTrail={handleAuditTrail}
                onHistoryByConcept={handleHistoryByConcept}
                onSearchTermChange={setSearchTerm}
            />
        </ExpandableContent>

    );
}